var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 8h8.45H12h.35zm.4-2h13.2l-.85-1H5.25zM9 12.75l2-1 2 1V8H9zM4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19V6.525q0-.35.112-.675.113-.325.338-.6L3.7 3.725q.274-.35.688-.538Q4.8 3 5.25 3h11.5q.45 0 .863.188.412.187.687.537l1.25 1.525q.225.274.337.6t.113.675v3.9q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712V8h-3v3.825a6 6 0 0 0-1.525 1.238 5.8 5.8 0 0 0-1.025 1.662L11 14l-2.55 1.275a.95.95 0 0 1-.975-.037Q7 14.95 7 14.375V8H4v11h7.775q.424 0 .713.288.287.287.287.712a.98.98 0 0 1-.287.7q-.288.3-.713.3zm14 0a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 20v-2h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 17q0-.424.287-.712A.97.97 0 0 1 15 16h2v-2q0-.424.288-.713A.97.97 0 0 1 18 13q.424 0 .712.287.288.288.288.713v2h2q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 21 18h-2v2q0 .424-.288.712A.97.97 0 0 1 18 21M4 8h8.45H12h.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAdd);
export default __webpack_public_path__ + "static/media/box_add.243b6b7eea20f88120fc2200e67e0592.svg";
export { ForwardRef as ReactComponent };